var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptIconsGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#34DAE2;}\n\t.st2{fill:#252A41;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#252A41;}\n\t.st4{fill:#E3E3E3;}\n\t.st5{opacity:0.1;fill:#231F20;enable-background:new    ;}\n\t.st6{fill:#D54B3D;}\n\t.st7{fill:#D72B27;}\n\t.st8{fill:url(#Path_677_1_);}\n\t.st9{fill:#005FAC;}\n\t.st10{fill:#5F01D1;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "google-gmail-seeklogo.com",
    transform: "translate(1324.785 652)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    className: "st4",
    d: "M-1299.91-628.54h-21.79c-0.86,0-1.55-0.7-1.55-1.56v-15.73c0-0.86,0.69-1.55,1.55-1.56h21.79 c0.86,0,1.55,0.7,1.56,1.56v15.73c0.01,0.85-0.68,1.55-1.54,1.56C-1299.89-628.54-1299.9-628.54-1299.91-628.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    className: "st5",
    d: "M-1320.14-628.54l9.31-7.49l0.07-0.4l-9.6-6.91l-0.02,14.47L-1320.14-628.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    className: "st6",
    d: "M-1321.69-628.54c-0.85,0-1.55-0.69-1.55-1.54c0-0.01,0-0.01,0-0.02v-15.76 c0-0.87,0.69-1.02,1.56-1.02c0.87,0,1.55,0.18,1.55,1.02v17.31H-1321.69z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    className: "st7",
    d: "M-1321.69-646.66c1.11,0,1.33,0.33,1.33,0.8v17.09h-1.33c-0.73,0-1.33-0.6-1.33-1.33v-15.76 C-1323.02-646.35-1322.8-646.66-1321.69-646.66L-1321.69-646.66z M-1321.69-646.88c-0.87,0-1.56,0.18-1.56,1.02v15.76 c-0.01,0.85,0.68,1.55,1.54,1.56c0.01,0,0.01,0,0.02,0h1.56v-17.31C-1320.13-646.72-1320.82-646.88-1321.69-646.88L-1321.69-646.88 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    className: "st6",
    d: "M-1299.91-628.54h-1.56v-17.36c0-0.87,0.69-0.98,1.56-0.98c0.87,0,1.56,0.11,1.56,0.98v15.82 C-1298.36-629.23-1299.05-628.54-1299.91-628.54C-1299.9-628.54-1299.91-628.54-1299.91-628.54z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    className: "st7",
    d: "M-1299.91-646.66c1,0,1.33,0.2,1.33,0.76v15.82c0,0.74-0.6,1.33-1.33,1.33h-1.33v-17.16 C-1301.24-646.48-1300.91-646.66-1299.91-646.66L-1299.91-646.66z M-1299.91-646.88c-0.87,0-1.56,0.11-1.56,0.98v17.38h1.56 c0.85,0.01,1.55-0.68,1.56-1.54c0-0.01,0-0.01,0-0.02v-15.82C-1298.35-646.77-1299.04-646.88-1299.91-646.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_677_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2236.3115,
    y1: -269.4057,
    x2: -2235.3115,
    y2: -269.4057,
    gradientTransform: "matrix(24.762 0 0 -17.1021 54052.4297 -5244.4893)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.102
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    className: "st8",
    d: "M-1306.58-628.54l-16.54-16.67l0.87,0.35l11.51,8.29l12.38-9.08v15.57 c0,0.85-0.7,1.54-1.55,1.53c0,0-0.01,0-0.01,0L-1306.58-628.54z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    className: "st6",
    d: "M-1310.82-636.03l-11.76-8.53c-0.7-0.5-0.87-1.47-0.38-2.18c0.53-0.69,1.51-0.84,2.22-0.33 l9.94,7.22l10-7.31c0.69-0.51,1.66-0.36,2.16,0.33c0.01,0.01,0.01,0.02,0.02,0.02c0.51,0.69,0.36,1.66-0.33,2.16 c-0.01,0.01-0.02,0.01-0.02,0.02L-1310.82-636.03L-1310.82-636.03z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    className: "st7",
    d: "M-1299.91-647.26L-1299.91-647.26c0.43,0,0.83,0.21,1.09,0.56c0.42,0.6,0.29,1.42-0.29,1.87 l-11.71,8.53l-11.62-8.45c-0.6-0.43-0.75-1.26-0.33-1.87c0.26-0.35,0.68-0.56,1.11-0.56c0.29,0,0.57,0.09,0.8,0.27l9.91,7.2 l0.13,0.09l0.13-0.09l9.98-7.31C-1300.47-647.17-1300.19-647.25-1299.91-647.26L-1299.91-647.26z M-1299.91-647.48 c-0.33,0-0.65,0.1-0.91,0.29l-10,7.31l-9.94-7.22c-0.27-0.19-0.6-0.3-0.93-0.29c-0.51,0-0.99,0.24-1.29,0.64 c-0.47,0.72-0.3,1.68,0.4,2.18l11.76,8.56l11.82-8.62c0.69-0.51,0.85-1.48,0.36-2.18C-1298.93-647.23-1299.4-647.48-1299.91-647.48 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptIconsGmail);
export default __webpack_public_path__ + "static/media/recrypt_icons_gmail.e96038d5.svg";
export { ForwardRef as ReactComponent };